import React, { HTMLAttributes } from 'react';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info' | 'primary';
  children: React.ReactNode;
}

/**
 * Badge component - Notion-inspired design
 * - Small pills for status indicators
 * - 4px × 10px padding
 * - 12px border radius (pill shape)
 * - 12px font, 600 weight
 */
export const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  children,
  className = '',
  ...props
}) => {
  const baseClasses =
    'inline-flex items-center justify-center px-2.5 py-1 rounded-full ' +
    'text-xs font-semibold transition-colors duration-200';

  const variantClasses = {
    default: 'bg-cream-200 text-black-light',
    success: 'bg-success-100 text-success-600',
    warning: 'bg-warning-100 text-warning-600',
    error: 'bg-error-100 text-error-600',
    info: 'bg-blue-100 text-blue-600',
    primary: 'bg-orange-100 text-orange-600',
  };

  const combinedClasses = `
    ${baseClasses}
    ${variantClasses[variant]}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <span className={combinedClasses} {...props}>
      {children}
    </span>
  );
};
